<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>

      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <div v-if="activeTab && activeTab === $route.path && activeTab === tab.route" >
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'accounting',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    permissions () {
      return this.$store.state.login.permissions
    },
    tabs () {
      const tabs = [
        { tabMenu: 'accounting.section', name: 'Accounting', route: `/accounting/accounting`, roles: ['manager', 'buyer'], permission: 'manual-purchase-orders-form' },
        { tabMenu: 'purchases.section', name: 'Purchases', route: `/accounting/purchases`, roles: ['manager', 'buyer'], permission: 'smart-purchase-orders-form' }
      ]
      return tabs.filter(tab => {
        if (tab.permission) {
          return this.permissions['purchase-orders'].components[tab.permission].visible
        }
        return tab.roles.includes(this.$is())
      })
    }
  }
}
</script>
